import { NgModule } from '@angular/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';

import { YAxisTicksComponent } from './y-axis-ticks.component';
import { YAxisComponent } from './y-axis.component';

@NgModule({
   imports: [NgxChartsModule],
   declarations: [YAxisComponent, YAxisTicksComponent],
   exports: [YAxisComponent, YAxisTicksComponent],
})
export class YAxisModule {}
